import React, { useEffect, useRef } from 'react';
import { translate } from '../Services/translation';

const StoreLocatorMarker = (props) => {
  const infoRef = useRef(null);

  useEffect(() => {
    if (props.mapsReference && infoRef.current) {
      props.mapsReference.OverlayView.preventMapHitsAndGesturesFrom(
        infoRef.current
      );
    }
  }, [props.mapsReference, infoRef.current]);

  const onCloseClick = () => {
    props.onClose();
  };

  const onDealerSelect = (e) => {
    props.onDealerSelect(e);
  };

  return (
    <div className="store-locator-marker">
      <div className="marker" />
      {props.show && (
        <div className="info-window" ref={infoRef}>
          <span className="close" onClick={onCloseClick}></span>
          <div className="content">
            <h2 className="name">{props.store.name}</h2>
            <div className="company">{props.store.company}</div>
            <div className="address">{props.store.address}</div>
            <a
              className={props.hideDealerSelect ? "link choosedealer-button" : "link"}
              href={props.store.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {translate('storelocator.visitlink')}
            </a>
            {!props.hideDealerSelect && (
              <span
                className="link choosedealer-button"
                onClick={onDealerSelect}
              >
                {translate('storelocator.choosedealer')}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreLocatorMarker;
